import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import User from '@/shared/models/User';
import Survey from '../models/Survey';
import SurveyDossier from '../models/SurveyDossier';
import SurveyFeedback from '../models/SurveyFeedback';
import SurveyResult from '../models/SurveyResult';

const SCHEMA = {
  id: 'id',
  createdOn: (data: any) => parseMoment(data.createdOn),
  createdBy: (data: any) => User.withFullNameAndAvatar(data.createdByName, data.createdByAvatar),
  dossier: parseDossier,
  result: parseResult,
  feedback: parseFeedback,
  finalized: 'isExcludedForFollowUp',
  isExpired: 'isExpired',
};

const DOSSIER_SCHEMA = {
  id: 'dossierId',
  externalReference: 'externalReference',
  outletId: 'moboOutletId',
  registrationNumber: 'registrationNumber',
  modelDescription: 'modelDescription',
  contactNames: 'contacts',
};

const RESULT_SCHEMA = {
  value: 'surveyResult',
  max: 'maxSurveyResult',
  comment: 'comment',
  source: 'resultBy',
  createdOn: (data: any) => parseMoment(data.resultOn),
};

const FEEDBACK_SCHEMA = {
  comment: 'followUp',
  modifiedOn: (data: any) => parseMoment(data.followUpModifiedOn),
  modifiedBy: (data: any) => User.withFullNameAndAvatar(data.followUpByName, data.followUpByAvatar),
};

function parseDossier(data: any): SurveyDossier | null {
  return parseEntity(data, DOSSIER_SCHEMA, SurveyDossier);
}

function parseResult(data: any): SurveyResult | null {
  if (!data.resultOn) return null;
  return parseEntity(data, RESULT_SCHEMA, SurveyResult);
}

function parseFeedback(data: any): SurveyFeedback | null {
  if (!data.followUp) return null;
  return parseEntity(data, FEEDBACK_SCHEMA, SurveyFeedback);
}

export function parseSurvey(data: any): Survey | null {
  return parseEntity(data, SCHEMA, Survey);
}

export function parseSurveys(data: any): Array<Survey> {
  return parseEntities(data, parseSurvey);
}
